// Module
var code = "<div class=\"divider\" hide-gt-xs></div>\n<equipment-grid-switch module=\"equipment\" identifier=\"{{$ctrl.identifier}}\"></equipment-grid-switch>\n";
// Exports
module.exports = code;